// @ts-nocheck
// import React, { useState } from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import Sidebar from './components/Sidebar';
// import TemplatePicker from './components/TemplatePicker';
// import ResumePreview from './components/ResumePreview';
// import PersonalTab from './components/tabs/PersonalTab';
// import EducationTab from './components/tabs/EducationTab';
// import ExperienceTab from './components/tabs/ExperienceTab';
// import ProjectsTab from './components/tabs/ProjectsTab';
// import SkillsTab from './components/tabs/SkillsTab';
// import CertificationsTab from './components/tabs/CertificationsTab';
// import ExtrasTab from './components/tabs/ExtrasTab';
// import { EMPTY_FORM, TABS } from './data/initialData';

// function drawCircularPhoto(src, sizePx) {
//   return new Promise((resolve) => {
//     const img = new Image();
//     img.onload = () => {
//       const c = document.createElement('canvas');
//       c.width = sizePx;
//       c.height = sizePx;
//       const ctx = c.getContext('2d');

//       // Clip to circle
//       ctx.beginPath();
//       ctx.arc(sizePx / 2, sizePx / 2, sizePx / 2, 0, Math.PI * 2);
//       ctx.clip();

//       // object-fit: cover â€” centre-crop the image to fill the square
//       const scale = Math.max(sizePx / img.naturalWidth, sizePx / img.naturalHeight);
//       const drawW = img.naturalWidth  * scale;
//       const drawH = img.naturalHeight * scale;
//       const offsetX = (sizePx - drawW) / 2;
//       const offsetY = (sizePx - drawH) / 2;
//       ctx.drawImage(img, offsetX, offsetY, drawW, drawH);

//       resolve(c.toDataURL('image/png'));
//     };
//     img.onerror = () => resolve(null);
//     img.src = src;
//   });
// }

// async function downloadAsPDF(form, templateId, customColor) {
//   const [{ default: html2canvas }, { default: jsPDF }] = await Promise.all([
//     import('html2canvas'),
//     import('jspdf'),
//   ]);

//   // â”€â”€ 1. Mount the resume into a hidden, fixed-width container â”€â”€
//   const container = document.createElement('div');
//   container.style.cssText =
//     'position:fixed;left:-9999px;top:0;width:816px;background:#fff;';
//   document.body.appendChild(container);

//   const root = ReactDOM.createRoot(container);
//   root.render(<ResumePreview data={form} templateId={templateId} customColor={customColor} />);

//   // Wait for React to paint
//   await new Promise((r) => setTimeout(r, 500));

//   // â”€â”€ 2. Pre-draw the profile photo as a clipped canvas element â”€â”€
//   // html2canvas cannot handle CSS object-fit:cover + border-radius on <img>,
//   // so we replace every .rp-photo with a <canvas> that has the image already
//   // drawn correctly as a centre-cropped circle.
//   const photoImgs = Array.from(container.querySelectorAll('img.rp-photo'));
//   for (const img of photoImgs) {
//     const src = img.getAttribute('src');
//     if (!src) continue;

//     const sizePx = img.offsetWidth || 82;
//     const circularDataURL = await drawCircularPhoto(src, sizePx * 2); // 2Ã— for retina
//     if (!circularDataURL) continue;

//     // Replace <img> with a <canvas> containing the pre-drawn circle
//     const replacement = document.createElement('canvas');
//     replacement.width  = sizePx * 2;
//     replacement.height = sizePx * 2;
//     replacement.style.cssText = `
//       width:${sizePx}px;
//       height:${sizePx}px;
//       border-radius:50%;
//       border:${img.style.border || '2.5px solid'};
//       display:block;
//       flex-shrink:0;
//       margin-top:4px;
//     `;
//     const ctx = replacement.getContext('2d');
//     const preDrawn = new Image();
//     await new Promise((res) => {
//       preDrawn.onload = res;
//       preDrawn.src = circularDataURL;
//     });
//     ctx.drawImage(preDrawn, 0, 0);

//     img.parentNode.replaceChild(replacement, img);
//   }

//   // One more tick for the DOM swap to settle
//   await new Promise((r) => setTimeout(r, 100));

//   try {
//     // â”€â”€ 3. Capture the full rendered height as a single canvas â”€â”€
//     const canvas = await html2canvas(container, {
//       scale: 2,
//       useCORS: true,
//       allowTaint: true,
//       backgroundColor: '#ffffff',
//       logging: false,
//       width: container.offsetWidth,
//       height: container.scrollHeight,
//       windowWidth: 816,
//       scrollX: 0,
//       scrollY: 0,
//     });

//     // â”€â”€ 4. Slice canvas into A4 pages â”€â”€
//     const PDF_W_MM = 210;
//     const PDF_H_MM = 297;
//     const pxPerMM      = canvas.width / PDF_W_MM;
//     const pageHeightPx = PDF_H_MM * pxPerMM;
//     const totalPages   = Math.ceil(canvas.height / pageHeightPx);

//     const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });

//     for (let page = 0; page < totalPages; page++) {
//       if (page > 0) pdf.addPage();

//       const pageCanvas    = document.createElement('canvas');
//       pageCanvas.width    = canvas.width;
//       pageCanvas.height   = pageHeightPx;

//       const ctx = pageCanvas.getContext('2d');
//       ctx.fillStyle = '#ffffff';
//       ctx.fillRect(0, 0, pageCanvas.width, pageCanvas.height);
//       ctx.drawImage(
//         canvas,
//         0, page * pageHeightPx,
//         canvas.width, pageHeightPx,
//         0, 0,
//         canvas.width, pageHeightPx,
//       );

//       pdf.addImage(pageCanvas.toDataURL('image/png'), 'PNG', 0, 0, PDF_W_MM, PDF_H_MM);
//     }

//     pdf.save(`${(form.personal.name || 'resume').replace(/\s+/g, '_')}_resume.pdf`);

//   } finally {
//     root.unmount();
//     document.body.removeChild(container);
//   }
// }

// export default function App() {
//   const [form, setForm] = useState(EMPTY_FORM);
//   const [template, setTemplate] = useState('classic');
//   const [customColor, setCustomColor] = useState(null);
//   const [activeTab, setActiveTab] = useState('personal');
//   const [isPreview, setIsPreview] = useState(false);
//   const [isExporting, setIsExporting] = useState(false);

//   const updatePersonal = (val) => setForm((f) => ({ ...f, personal: val }));
//   const updateEducation = (val) => setForm((f) => ({ ...f, education: val }));
//   const updateExperience = (val) => setForm((f) => ({ ...f, experience: val }));
//   const updateProjects = (val) => setForm((f) => ({ ...f, projects: val }));
//   const updateSkills = (val) => setForm((f) => ({ ...f, skills: val }));
//   const updateCertifications = (val) => setForm((f) => ({ ...f, certifications: val }));
//   const updateExtras = (key, val) => setForm((f) => ({ ...f, [key]: val }));

//   const tabIds = TABS.map((t) => t.id);
//   const currentTabIdx = tabIds.indexOf(activeTab);
//   const goNext = () => { if (currentTabIdx < tabIds.length - 1) setActiveTab(tabIds[currentTabIdx + 1]); setIsPreview(false); };
//   const goBack = () => { if (currentTabIdx > 0) setActiveTab(tabIds[currentTabIdx - 1]); setIsPreview(false); };

//   // â”€â”€ DOWNLOAD PDF directly (no print dialog) â”€â”€
//   const handleDownloadPDF = async () => {
//     setIsExporting(true);
//     try {
//       await downloadAsPDF(form, template, customColor);
//     } catch (err) {
//       console.error('PDF generation failed:', err);
//       alert('PDF generation failed. Please try again.');
//     } finally {
//       setIsExporting(false);
//     }
//   };

//   const handleTabChange = (tab) => { setActiveTab(tab); setIsPreview(false); };

//   return (
//     <div className="app-layout">
//       <Sidebar
//         activeTab={activeTab}
//         onTabChange={handleTabChange}
//         onPreview={() => setIsPreview((p) => !p)}
//         onDownloadPDF={handleDownloadPDF}
//         isPreview={isPreview}
//         isExporting={isExporting}
//       />

//       <div className="app-main">
//         <TemplatePicker
//           selected={template}
//           onSelect={(t) => { setTemplate(t); setCustomColor(null); }}
//           customColor={customColor}
//           onColorChange={setCustomColor}
//         />

//         <div className="app-content">
//           {isPreview ? (
//             <div className="preview-wrapper">
//               <div className="preview-toolbar">
//                 <button className="preview-edit-btn" onClick={() => setIsPreview(false)}>âœï¸ Back to Edit</button>
//                 <button className="preview-download-btn" onClick={handleDownloadPDF} disabled={isExporting}>
//                   {isExporting ? 'â³ Generating PDF...' : 'â¬‡ï¸ Download PDF'}
//                 </button>
//               </div>
//               <div className="preview-paper">
//                 <ResumePreview data={form} templateId={template} customColor={customColor} />
//               </div>
//             </div>
//           ) : (
//             <div className="form-wrapper">
//               <div className="form-panel">
//                 <div className="form-panel-header">
//                   <div className="form-tab-title">
//                     {TABS.find((t) => t.id === activeTab)?.icon}{' '}
//                     {TABS.find((t) => t.id === activeTab)?.label}
//                   </div>
//                   <div className="form-progress">Step {currentTabIdx + 1} of {TABS.length}</div>
//                 </div>
//                 <div className="progress-bar">
//                   <div className="progress-fill" style={{ width: `${((currentTabIdx + 1) / TABS.length) * 100}%` }} />
//                 </div>
//                 <div className="form-body">
//                   {activeTab === 'personal' && <PersonalTab data={form.personal} onChange={updatePersonal} onNext={goNext} />}
//                   {activeTab === 'education' && <EducationTab data={form.education} onChange={updateEducation} onBack={goBack} onNext={goNext} />}
//                   {activeTab === 'experience' && <ExperienceTab data={form.experience} onChange={updateExperience} onBack={goBack} onNext={goNext} />}
//                   {activeTab === 'projects' && <ProjectsTab data={form.projects} onChange={updateProjects} onBack={goBack} onNext={goNext} />}
//                   {activeTab === 'skills' && <SkillsTab data={form.skills} onChange={updateSkills} onBack={goBack} onNext={goNext} />}
//                   {activeTab === 'certifications' && <CertificationsTab data={form.certifications} onChange={updateCertifications} onBack={goBack} onNext={goNext} />}
//                   {activeTab === 'extras' && <ExtrasTab achievements={form.achievements} volunteering={form.volunteering} onChange={updateExtras} onBack={goBack} onPreview={() => setIsPreview(true)} />}
//                 </div>
//               </div>

//               <div className="mini-preview">
//                 <div className="mini-preview-label">Live Preview</div>
//                 <div className="mini-preview-frame">
//                   <div className="mini-preview-scale">
//                     <ResumePreview data={form} templateId={template} customColor={customColor} />
//                   </div>
//                 </div>
//                 <button className="mini-preview-fullbtn" onClick={() => setIsPreview(true)}>View Full Preview â†’</button>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import Alert from "@mui/material/Alert";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import Snackbar from "@mui/material/Snackbar";
import { useNavigate, useParams } from "react-router-dom";
import "./index.css";
import "./App.css";
import Sidebar from "./components/Sidebar";
import TemplatePicker from "./components/TemplatePicker";
import ResumePreview from "./components/ResumePreview";
import { getTabIcon } from "./components/tab-icons";
import PersonalTab from "./components/tabs/PersonalTab";
import EducationTab from "./components/tabs/EducationTab";
import ExperienceTab from "./components/tabs/ExperienceTab";
import ProjectsTab from "./components/tabs/ProjectsTab";
import SkillsTab from "./components/tabs/SkillsTab";
import CertificationsTab from "./components/tabs/CertificationsTab";
import CustomSectionTab from "./components/tabs/CustomSectionTab";
import { EMPTY_FORM, TABS } from "./data/initialData";
import { downloadResumePDF, generateResumePDFBlob } from "./components/ResumePDF";
import { createResume, findResumeById, updateResume } from "@/client/services/resume";
import { queryClient } from "@/client/libs/query-client";
import { RESUMES_KEY } from "@/client/constants/query-keys";

const BUILDER_NOTE_PREFIX = "RESUME_BUILDER_V1::";

function createBuilderPayload(form, template, customColor, fontStyle) {
  return {
    form,
    template,
    customColor,
    fontStyle,
    savedAt: new Date().toISOString(),
  };
}

function parseBuilderPayload(resume) {
  try {
    const notes = resume?.data?.metadata?.notes ?? "";
    if (!notes.startsWith(BUILDER_NOTE_PREFIX)) return null;
    return JSON.parse(notes.slice(BUILDER_NOTE_PREFIX.length));
  } catch (_) {
    return null;
  }
}

function withBuilderPayload(resumeData, payload, customColor) {
  return {
    ...resumeData,
    metadata: {
      ...resumeData.metadata,
      notes: `${BUILDER_NOTE_PREFIX}${JSON.stringify(payload)}`,
      theme: {
        ...resumeData.metadata.theme,
        primary: customColor || resumeData.metadata.theme?.primary || "#1976d2",
      },
    },
  };
}

function snapshotState(form, template, customColor, fontStyle) {
  return JSON.stringify({ form, template, customColor, fontStyle });
}

function countWords(value) {
  return String(value || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean).length;
}

function splitList(value) {
  return String(value || "")
    .split(/[\n,;]+/)
    .map((item) => item.trim())
    .filter(Boolean);
}

function hasMetric(value) {
  return /\b(\d+%?|\$[0-9]|[0-9]+\+|[0-9]+x)\b/i.test(String(value || ""));
}

function hasActionVerb(value) {
  return /\b(achieved|automated|built|created|decreased|delivered|designed|developed|improved|increased|launched|led|managed|optimized|reduced|resolved|shipped|streamlined)\b/i.test(
    String(value || ""),
  );
}

function scoreItem(condition, points, label, passedDetail, failedDetail) {
  return {
    label,
    points,
    earned: condition ? points : 0,
    passed: Boolean(condition),
    detail: condition ? passedDetail : failedDetail,
  };
}

function calculateAtsScore(form, templateId) {
  const personal = form.personal || {};
  const education = (form.education || []).filter(
    (item) => item.school || item.degree || item.field,
  );
  const experience = (form.experience || []).filter(
    (item) => item.company || item.role || item.bullets,
  );
  const projects = (form.projects || []).filter(
    (item) => item.name || item.description || item.tech,
  );
  const certifications = (form.certifications || []).filter((item) => item.name);
  const skills = form.skills || {};
  const skillItems = [
    ...splitList(skills.languages),
    ...splitList(skills.frameworks),
    ...splitList(skills.databases),
    ...splitList(skills.cloud),
    ...splitList(skills.technical),
    ...splitList(skills.soft),
  ];
  const allBullets = experience.flatMap((item) => splitList(item.bullets));
  const quantifiedBullets = allBullets.filter(hasMetric).length;
  const actionBullets = allBullets.filter(hasActionVerb).length;
  const projectTechItems = projects.flatMap((item) => splitList(item.tech));
  const checks = [
    scoreItem(
      personal.name && personal.email && personal.phone,
      12,
      "Core contact details",
      "Name, email, and phone are present.",
      "Add name, email, and phone so recruiters can parse contact data.",
    ),
    scoreItem(
      personal.location && (personal.linkedin || personal.github || personal.portfolio),
      8,
      "Location and profile links",
      "Location plus at least one profile link is included.",
      "Add location and one profile link such as LinkedIn, GitHub, or portfolio.",
    ),
    scoreItem(
      countWords(personal.summary) >= 25 && countWords(personal.summary) <= 80,
      10,
      "Professional summary",
      "Summary length is ATS-friendly.",
      "Write a focused 25-80 word summary with role, skills, and impact.",
    ),
    scoreItem(
      education.length > 0 && education.some((item) => item.degree || item.field),
      10,
      "Education details",
      "Education includes degree or field details.",
      "Add school, degree, field, and dates where available.",
    ),
    scoreItem(
      experience.length > 0 && allBullets.length >= 3,
      14,
      "Experience bullets",
      "Experience includes enough bullet points.",
      "Add at least three experience bullets, even for internships or academic work.",
    ),
    scoreItem(
      actionBullets >= Math.min(3, allBullets.length || 3),
      8,
      "Action verbs",
      "Bullets use strong action verbs.",
      "Start more bullets with verbs like Built, Improved, Led, Optimized, or Delivered.",
    ),
    scoreItem(
      quantifiedBullets >= 2,
      10,
      "Measurable impact",
      "Resume includes quantified impact.",
      "Add numbers, percentages, scale, users, revenue, time saved, or performance gains.",
    ),
    scoreItem(
      projects.length > 0 && projectTechItems.length >= 3,
      10,
      "Projects and technologies",
      "Projects include technology keywords.",
      "Add projects with specific tools, languages, frameworks, and outcomes.",
    ),
    scoreItem(
      skillItems.length >= 8,
      12,
      "Keyword-rich skills",
      "Skills section has enough searchable keywords.",
      "Add at least eight specific skills separated by commas.",
    ),
    scoreItem(
      certifications.length > 0 || (form.customSections || []).some(s => s.title && s.items),
      6,
      "Extra credibility",
      "Resume includes certifications or custom sections (achievements, volunteering, publications, etc).",
      "Add certifications, awards, leadership, volunteering, or hackathon wins via the Custom Sections tab.",
    ),
  ];

  const rawScore = checks.reduce((sum, item) => sum + item.earned, 0);
  const penaltyItems = [];
  if (personal.photo) {
    penaltyItems.push({
      label: "Profile photo attached",
      points: -4,
      detail: "Remove the profile photo for ATS submissions; many parsers ignore or mishandle images.",
    });
  }
  if (templateId === "sidebar") {
    penaltyItems.push({
      label: "Sidebar template layout",
      points: -3,
      detail: "Use a single-column template for strict ATS portals; sidebar layouts can parse less reliably.",
    });
  }
  const totalPenalty = penaltyItems.reduce((sum, p) => sum + p.points, 0);
  const score = Math.max(0, Math.min(100, rawScore + totalPenalty));
  const suggestions = [
    ...penaltyItems.map((p) => p.detail),
    ...checks.filter((item) => !item.passed).map((item) => item.detail),
  ].slice(0, 5);

  return {
    score,
    rawScore,
    totalPenalty,
    grade: score >= 85 ? "Excellent" : score >= 70 ? "Good" : score >= 55 ? "Needs work" : "Weak",
    checks,
    penaltyItems,
    suggestions,
  };
}

/**
 * Draws an image as a cropped circle (object-fit:cover equivalent) onto a
 * canvas. Bypasses html2canvas's inability to handle CSS object-fit + border-radius.
 */
function drawCircularPhoto(src, sizePx) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const c = document.createElement("canvas");
      c.width = sizePx;
      c.height = sizePx;
      const ctx = c.getContext("2d");
      ctx.beginPath();
      ctx.arc(sizePx / 2, sizePx / 2, sizePx / 2, 0, Math.PI * 2);
      ctx.clip();
      const scale = Math.max(sizePx / img.naturalWidth, sizePx / img.naturalHeight);
      const drawW = img.naturalWidth * scale,
        drawH = img.naturalHeight * scale;
      ctx.drawImage(img, (sizePx - drawW) / 2, (sizePx - drawH) / 2, drawW, drawH);
      resolve(c.toDataURL("image/png"));
    };
    img.onerror = () => resolve(null);
    img.src = src;
  });
}

function getPageStarts(container, pageHeightPx, bottomMarginPx = 40) {
  const containerTop = container.getBoundingClientRect().top;

  const coarseBlocks = Array.from(
    container.querySelectorAll(
      ".rp-section, .rp-entry, .rp-bold-header, .rp-elegant-header, header",
    ),
  );
  const fineBlocks = Array.from(
    container.querySelectorAll(
      ".rp-bullets li, .rp-skill-row, .rp-cert-row, .rp-courses, .rp-project-desc",
    ),
  );

  const starts = [0];
  const fullH = container.scrollHeight;
  let start = 0;

  while (start + pageHeightPx < fullH) {
    const hardLimit = start + pageHeightPx; // true page boundary
    const softLimit = hardLimit - bottomMarginPx; // where content should stop, leaving breathing room

    // 1. Prefer breaking between whole sections/entries within the soft limit.
    let bestBreak = softLimit; // last-resort hard cut if nothing better found
    let lastFittingBlock = null;

    for (const block of coarseBlocks) {
      const rect = block.getBoundingClientRect();
      const blockTop = rect.top - containerTop;
      const blockBottom = rect.bottom - containerTop;

      if (blockTop < start) continue;

      if (blockBottom <= softLimit) {
        lastFittingBlock = block;
      }

      if (blockTop >= softLimit) break;
    }

    // 2. Find the section/entry straddling the soft limit (didn't fully fit).
    const straddler = coarseBlocks.find((block) => {
      const rect = block.getBoundingClientRect();
      const blockTop = rect.top - containerTop;
      const blockBottom = rect.bottom - containerTop;
      return blockTop >= start && blockTop < softLimit && blockBottom > softLimit;
    });

    // 3. Only subdivide with fine-grained breaks if that block is too tall
    //    to ever fit on a fresh page by itself.
    if (straddler) {
      const rect = straddler.getBoundingClientRect();
      const blockTop = rect.top - containerTop;
      const blockHeight = rect.height;

      if (blockHeight > pageHeightPx - bottomMarginPx) {
        let fineBreak = null;
        for (const fb of fineBlocks) {
          const fbRect = fb.getBoundingClientRect();
          const fbTop = fbRect.top - containerTop;
          const fbBottom = fbRect.bottom - containerTop;
          if (fbTop >= blockTop && fbBottom <= softLimit) fineBreak = fbBottom;
          if (fbTop >= softLimit) break;
        }
        if (fineBreak && fineBreak > bestBreak) bestBreak = fineBreak;
      }
    }

    let nextStart;

    if (lastFittingBlock) {
      const blocks = coarseBlocks;
      const idx = blocks.indexOf(lastFittingBlock);

      if (idx + 1 < blocks.length) {
        const rect = blocks[idx + 1].getBoundingClientRect();
        nextStart = Math.floor(rect.top - containerTop);
      } else {
        nextStart = Math.floor(fullH);
      }
    } else {
      nextStart = Math.floor(start + pageHeightPx);
    }
    starts.push(nextStart);
    start = nextStart;
  }

  return starts;
}

/**
 * Renders <ResumePreview> off-screen, finds section-aware page breaks,
 * then builds a PDF where each page starts cleanly at a section boundary.
 */
async function downloadAsPDF(form, templateId, customColor) {
  const [{ default: html2canvas }, { default: jsPDF }] = await Promise.all([
    import("html2canvas"),
    import("jspdf"),
  ]);

  const PAGE_W_PX = 816;
  const PAGE_H_PX = 1056; // must match preview page geometry
  const EXPORT_SCALE = 2;
  const PDF_W_MM = 210;
  const PDF_H_MM = (PDF_W_MM * PAGE_H_PX) / PAGE_W_PX; // match preview aspect ratio exactly

  // Margins — mirror the on-screen preview padding (48px ≈ 12.7mm at 96dpi)
  const TOP_MARGIN_MM = 12.7;
  const BOTTOM_MARGIN_MM = 12.7;
  const TOP_MARGIN_PX = 48;
  const BOTTOM_MARGIN_PX = 48;

  // â”€â”€ 1. Mount off-screen â”€â”€
  const container = document.createElement("div");
  container.style.cssText = "position:fixed;left:-9999px;top:0;width:816px;background:#fff;";
  document.body.appendChild(container);

  const root = ReactDOM.createRoot(container);
  root.render(<ResumePreview data={form} templateId={templateId} customColor={customColor} />);
  await new Promise((r) => setTimeout(r, 600));
  // Ensure webfonts are fully loaded before layout measurement/capture.
  if (document.fonts && document.fonts.ready) {
    try {
      await document.fonts.ready;
    } catch (_) {}
  }
  await new Promise(requestAnimationFrame);

  // â”€â”€ 2. Replace profile photo <img> with pre-drawn circular <canvas> â”€â”€
  for (const img of Array.from(container.querySelectorAll("img.rp-photo"))) {
    const src = img.getAttribute("src");
    if (!src) continue;
    const sizePx = img.offsetWidth || 82;
    const dataURL = await drawCircularPhoto(src, sizePx * 2);
    if (!dataURL) continue;
    const cv = document.createElement("canvas");
    cv.width = sizePx * 2;
    cv.height = sizePx * 2;

    // Preserve computed positioning so html2canvas keeps centering intact
    const computed = window.getComputedStyle(img);
    cv.style.width = `${sizePx}px`;
    cv.style.height = `${sizePx}px`;
    cv.style.borderRadius = "50%";
    cv.style.display = "block";
    cv.style.flexShrink = "0";
    cv.style.marginTop = computed.marginTop !== "auto" ? computed.marginTop : "0px";
    cv.style.marginBottom = computed.marginBottom !== "auto" ? computed.marginBottom : "0px";
    cv.style.marginLeft = computed.marginLeft !== "auto" ? computed.marginLeft : "0px";
    cv.style.marginRight = computed.marginRight !== "auto" ? computed.marginRight : "0px";
    cv.style.alignSelf = computed.alignSelf !== "auto" ? computed.alignSelf : "";

    const preDrawn = new Image();
    await new Promise((res) => {
      preDrawn.onload = res;
      preDrawn.src = dataURL;
    });
    cv.getContext("2d").drawImage(preDrawn, 0, 0);
    img.parentNode.replaceChild(cv, img);
  }
  await new Promise((r) => setTimeout(r, 100));
  if (document.fonts && document.fonts.ready) {
    try {
      await document.fonts.ready;
    } catch (_) {}
  }
  await new Promise(requestAnimationFrame);

  try {
    // â”€â”€ 3. Capture full content as one big canvas â”€â”€
    const canvas = await html2canvas(container, {
      scale: EXPORT_SCALE,
      useCORS: true,
      allowTaint: true,
      backgroundColor: "#ffffff",
      logging: false,
      width: container.offsetWidth,
      height: container.scrollHeight,
      windowWidth: PAGE_W_PX,
      scrollX: 0,
      scrollY: 0,
    });

    const pageStarts = getPageStarts(container, PAGE_H_PX - TOP_MARGIN_PX - BOTTOM_MARGIN_PX);

    const slices = [];
    for (let i = 0; i < pageStarts.length; i++) {
      const start = pageStarts[i];
      const end = i + 1 < pageStarts.length ? pageStarts[i + 1] : container.scrollHeight;
      slices.push({ start, end });
    }

    const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: [PDF_W_MM, PDF_H_MM] });

    slices.forEach((slice, i) => {
      if (i > 0) pdf.addPage();

      const sliceStartPx = Math.max(0, Math.round(slice.start * EXPORT_SCALE));
      const sliceEndPx = Math.min(canvas.height, Math.round(slice.end * EXPORT_SCALE));
      const sliceH = Math.max(1, sliceEndPx - sliceStartPx);
      const sliceHmm = (sliceH / canvas.width) * PDF_W_MM;

      // White page background
      pdf.setFillColor(255, 255, 255);
      pdf.rect(0, 0, PDF_W_MM, PDF_H_MM, "F");

      const pageCanvas = document.createElement("canvas");
      pageCanvas.width = canvas.width;
      pageCanvas.height = sliceH;
      const ctx = pageCanvas.getContext("2d");
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, pageCanvas.width, pageCanvas.height);
      ctx.drawImage(canvas, 0, sliceStartPx, canvas.width, sliceH, 0, 0, canvas.width, sliceH);

      // Only offset top margin for pages after the first — matches your preview rule
      const topOffset = i > 0 ? TOP_MARGIN_MM : 0;

      pdf.addImage(pageCanvas.toDataURL("image/png"), "PNG", 0, topOffset, PDF_W_MM, sliceHmm);
    });

    pdf.save(`${(form.personal.name || "resume").replace(/\s+/g, "_")}_resume.pdf`);
  } finally {
    root.unmount();
    document.body.removeChild(container);
  }
}

const PAGE_W = 816;
const PAGE_H = 1056; // pixel height of an A4 page at 96 dpi

// PDFPreview
// ────────────────────────────────────────────────────────────────────────────
// Renders the *actual* resume PDF in an <iframe>. We use the real PDF blob
// (generated by the same code path that downloadResumePDF uses) so the
// preview is pixel-identical to the download — same fonts, same page breaks,
// same margins, same photo cropping. The HTML-only PaginatedPreview that
// used to live here could never match the PDF renderer exactly, so we now
// go straight to the source.
function PDFPreview({ data, templateId, customColor, fontStyle }) {
  const [blobUrl, setBlobUrl] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    let cancelled = false;
    let lastUrl = null;

    const run = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const blob = await generateResumePDFBlob(data, templateId, customColor, fontStyle);
        if (cancelled) return;
        const url = URL.createObjectURL(blob);
        lastUrl = url;
        setBlobUrl(url);
      } catch (err) {
        if (cancelled) return;
        console.error("PDF preview generation failed:", err);
        setError(err);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };

    // Debounce so rapid edits don't re-render the PDF on every keystroke
    const timer = setTimeout(run, 300);

    return () => {
      cancelled = true;
      clearTimeout(timer);
      if (lastUrl) URL.revokeObjectURL(lastUrl);
    };
  }, [data, templateId, customColor, fontStyle]);

  return (
    <div className="pdf-preview">
      {isLoading && (
        <div className="pdf-preview-loading">
          <div className="pdf-preview-spinner" />
          <span>Rendering preview…</span>
        </div>
      )}
      {error && !isLoading && (
        <div className="pdf-preview-error">
          Could not render preview: {error.message || "Unknown error"}
        </div>
      )}
      {blobUrl && (
        <iframe
          key={blobUrl}
          src={blobUrl}
          title="Resume PDF preview"
          className="pdf-preview-iframe"
        />
      )}
    </div>
  );
}

export default function App() {
  const navigate = useNavigate();
  const { id: routeResumeId } = useParams();

  const [form, setForm] = useState(EMPTY_FORM);
  const [template, setTemplate] = useState("classic");
  const [customColor, setCustomColor] = useState(null);
  const [fontStyle, setFontStyle] = useState("template");
  const [currentResumeId, setCurrentResumeId] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [activeTab, setActiveTab] = useState("personal");
  const [isPreview, setIsPreview] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [atsResult, setAtsResult] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const [lastSavedSnapshot, setLastSavedSnapshot] = useState(() =>
    snapshotState(EMPTY_FORM, "classic", null, "template"),
  );

  const updatePersonal = (val) => setForm((f) => ({ ...f, personal: val }));
  const updateEducation = (val) => setForm((f) => ({ ...f, education: val }));
  const updateExperience = (val) => setForm((f) => ({ ...f, experience: val }));
  const updateProjects = (val) => setForm((f) => ({ ...f, projects: val }));
  const updateSkills = (val) => setForm((f) => ({ ...f, skills: val }));
  const updateCertifications = (val) => setForm((f) => ({ ...f, certifications: val }));
  const updateCustomSections = (val) => setForm((f) => ({ ...f, customSections: val }));

  const tabIds = TABS.map((t) => t.id);
  const currentTabIdx = tabIds.indexOf(activeTab);
  const goNext = () => {
    if (currentTabIdx < tabIds.length - 1) setActiveTab(tabIds[currentTabIdx + 1]);
    setIsPreview(false);
  };
  const goBack = () => {
    if (currentTabIdx > 0) setActiveTab(tabIds[currentTabIdx - 1]);
    setIsPreview(false);
  };

  React.useEffect(() => {
    const bootstrapFromRoute = async () => {
      if (!routeResumeId) {
        setLastSavedSnapshot(snapshotState(EMPTY_FORM, "classic", null, "template"));
        return;
      }

      try {
        const resume = await findResumeById({ id: routeResumeId });
        const payload = parseBuilderPayload(resume);

        if (!payload) {
          alert("This resume was not created in the custom resume builder format.");
          return;
        }

        setForm(payload.form || EMPTY_FORM);
        setTemplate(payload.template || "classic");
        setCustomColor(payload.customColor || null);
        setFontStyle(payload.fontStyle || "template");
        setCurrentResumeId(resume.id);
        setLastSavedSnapshot(
          snapshotState(
            payload.form || EMPTY_FORM,
            payload.template || "classic",
            payload.customColor || null,
            payload.fontStyle || "template",
          ),
        );
      } catch (error) {
        console.error("Failed to load resume from route:", error);
        alert("Unable to load the selected resume.");
      }
    };

    bootstrapFromRoute();
  }, [routeResumeId]);

  const isDirty = snapshotState(form, template, customColor, fontStyle) !== lastSavedSnapshot;

  React.useEffect(() => {
    const onBeforeUnload = (event) => {
      if (!isDirty) return;
      event.preventDefault();
      event.returnValue = "";
    };

    window.addEventListener("beforeunload", onBeforeUnload);
    return () => window.removeEventListener("beforeunload", onBeforeUnload);
  }, [isDirty]);

  const handleDownloadPDF = async () => {
    setIsExporting(true);
    try {
      await downloadResumePDF(form, template, customColor, fontStyle);
    } catch (err) {
      console.error("PDF generation failed:", err);
      alert("PDF generation failed. Please try again.");
    } finally {
      setIsExporting(false);
    }
  };

  const handleGenerateAtsScore = () => {
    const result = calculateAtsScore(form, template);
    setAtsResult(result);
    setIsPreview(true);
    setSnackbar({
      open: true,
      message: `ATS score generated: ${result.score}/100`,
      severity: result.score >= 70 ? "success" : "warning",
    });
  };

  const handleSaveResume = async () => {
    setIsSaving(true);
    try {
      const payload = createBuilderPayload(form, template, customColor, fontStyle);
      const title = form?.personal?.name?.trim() || "Untitled Resume";
      const isUpdating = !!currentResumeId;

      if (!currentResumeId) {
        const created = await createResume({ title, visibility: "private" });
        await updateResume({
          id: created.id,
          title,
          visibility: created.visibility,
          data: withBuilderPayload(created.data, payload, customColor),
        });
        setCurrentResumeId(created.id);
        navigate(`/resume-builder/${created.id}`, { replace: true });
      } else {
        const fullResume = await findResumeById({ id: currentResumeId });
        await updateResume({
          id: currentResumeId,
          title,
          visibility: fullResume.visibility,
          data: withBuilderPayload(fullResume.data, payload, customColor),
        });
      }

      setSnackbar({
        open: true,
        message: isUpdating ? "Resume updated successfully." : "Resume saved successfully.",
        severity: "success",
      });
      setLastSavedSnapshot(snapshotState(form, template, customColor, fontStyle));
      // Invalidate the resumes list cache so navigating back shows the new/updated resume
      queryClient.invalidateQueries({ queryKey: RESUMES_KEY });
    } catch (error) {
      console.error("Failed to save resume:", error);
      setSnackbar({
        open: true,
        message: "Failed to save resume. Please try again.",
        severity: "error",
      });
    } finally {
      setIsSaving(false);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const handleBackToResumes = () => {
    if (isDirty) {
      setSnackbar({
        open: true,
        message: "You have unsaved changes. Please save your resume before leaving.",
        severity: "warning",
      });
      return;
    }
    navigate("/resume-builder");
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setIsPreview(false);
  };

  return (
    <div className="app-layout">
      <div className="rb-back-wrap">
        <button className="rb-back-link" onClick={handleBackToResumes}>
          <ArrowBackOutlinedIcon fontSize="inherit" /> Back to Resumes
        </button>
      </div>
      <Sidebar
        activeTab={activeTab}
        onTabChange={handleTabChange}
        onPreview={() => setIsPreview((p) => !p)}
        onDownloadPDF={handleDownloadPDF}
        onSaveResume={handleSaveResume}
        onGenerateAtsScore={handleGenerateAtsScore}
        isPreview={isPreview}
        isExporting={isExporting}
        isSaving={isSaving}
        isEditingResume={!!currentResumeId}
      />

      <div className="app-main">
        <div className="app-content">
          {isPreview ? (
            <div className="preview-layout">
              <div className="preview-wrapper">
                <div className="preview-toolbar">
                  <button className="preview-edit-btn" onClick={() => setIsPreview(false)}>
                    <EditOutlinedIcon fontSize="inherit" /> Back to Edit
                  </button>
                  <button
                    className="preview-download-btn"
                    onClick={handleDownloadPDF}
                    disabled={isExporting}
                  >
                    {!isExporting && <PictureAsPdfOutlinedIcon fontSize="inherit" />}{" "}
                    {isExporting ? "Generating PDF..." : "Download PDF"}
                  </button>
                  <button className="preview-ats-btn" onClick={handleGenerateAtsScore}>
                    <FactCheckOutlinedIcon fontSize="inherit" /> Generate ATS Score
                  </button>
                </div>
                {atsResult && (
                  <div className="ats-score-panel">
                    <div className="ats-score-summary">
                      <div>
                        <div className="ats-score-eyebrow">ATS Resume Score</div>
                        <div className="ats-score-title">{atsResult.grade}</div>
                      </div>
                      <div className="ats-score-actions">
                        <div
                          className="ats-score-meter"
                          aria-label={`ATS score ${atsResult.score} out of 100`}
                        >
                          <span>{atsResult.score}</span>
                          <small>/100</small>
                        </div>
                        <button
                          className="ats-score-close"
                          type="button"
                          onClick={() => setAtsResult(null)}
                          aria-label="Close ATS score"
                        >
                          <CloseOutlinedIcon fontSize="inherit" />
                        </button>
                      </div>
                    </div>

                    {atsResult.totalPenalty < 0 && (
                      <div className="ats-score-breakdown" aria-label="Score breakdown">
                        Raw {atsResult.rawScore} − penalty {Math.abs(atsResult.totalPenalty)} = <strong>{atsResult.score}</strong>
                      </div>
                    )}

                    <div className="ats-score-bar">
                      <div style={{ width: `${atsResult.score}%` }} />
                    </div>

                    <div className="ats-score-grid">
                      {atsResult.checks.map((check) => (
                        <div
                          key={check.label}
                          className={`ats-check ${check.passed ? "passed" : "failed"}`}
                        >
                          <div className="ats-check-top">
                            <span>{check.passed ? "Pass" : "Fix"}</span>
                            <strong>
                              {check.earned}/{check.points}
                            </strong>
                          </div>
                          <div className="ats-check-label">{check.label}</div>
                          <p>{check.detail}</p>
                        </div>
                      ))}
                      {atsResult.penaltyItems && atsResult.penaltyItems.map((penalty) => (
                        <div
                          key={penalty.label}
                          className="ats-check ats-check--penalty"
                        >
                          <div className="ats-check-top">
                            <span>Penalty</span>
                            <strong>{penalty.points}</strong>
                          </div>
                          <div className="ats-check-label">{penalty.label}</div>
                          <p>{penalty.detail}</p>
                        </div>
                      ))}
                    </div>

                    {/* {atsResult.suggestions.length > 0 && (
                      <div className="ats-suggestions">
                        <div className="ats-suggestions-title">Top improvements</div>
                        {atsResult.suggestions.map((suggestion, index) => (
                          <div key={index} className="ats-suggestion">{suggestion}</div>
                        ))}
                      </div>
                    )} */}
                  </div>
                )}
                <PDFPreview
                  data={form}
                  templateId={template}
                  customColor={customColor}
                  fontStyle={fontStyle}
                />
              </div>

              <div className="preview-template-rail">
                <TemplatePicker
                  selected={template}
                  onSelect={(t) => {
                    setTemplate(t);
                    setCustomColor(null);
                  }}
                  customColor={customColor}
                  onColorChange={setCustomColor}
                  selectedFontStyle={fontStyle}
                  onFontStyleChange={setFontStyle}
                />
              </div>
            </div>
          ) : (
            <div className="form-wrapper">
              <div className="form-panel">
                {/* <div className="form-panel-header">
                  <div className="form-tab-title">
                    {getTabIcon(activeTab)} {TABS.find((t) => t.id === activeTab)?.label}
                  </div>
                  <div className="form-progress">
                    {currentTabIdx + 1} / {TABS.length}
                  </div>
                </div> */}
                <div className="progress-bar">
                  <div
                    className="progress-fill"
                    style={{ width: `${((currentTabIdx + 1) / TABS.length) * 100}%` }}
                  />
                </div>
                <div className="form-body">
                  {activeTab === "personal" && (
                    <PersonalTab data={form.personal} onChange={updatePersonal} onNext={goNext} />
                  )}
                  {activeTab === "education" && (
                    <EducationTab
                      data={form.education}
                      onChange={updateEducation}
                      onBack={goBack}
                      onNext={goNext}
                    />
                  )}
                  {activeTab === "experience" && (
                    <ExperienceTab
                      data={form.experience}
                      onChange={updateExperience}
                      onBack={goBack}
                      onNext={goNext}
                    />
                  )}
                  {activeTab === "projects" && (
                    <ProjectsTab
                      data={form.projects}
                      onChange={updateProjects}
                      onBack={goBack}
                      onNext={goNext}
                    />
                  )}
                  {activeTab === "skills" && (
                    <SkillsTab
                      data={form.skills}
                      onChange={updateSkills}
                      onBack={goBack}
                      onNext={goNext}
                    />
                  )}
                  {activeTab === "certifications" && (
                    <CertificationsTab
                      data={form.certifications}
                      onChange={updateCertifications}
                      onBack={goBack}
                      onNext={goNext}
                    />
                  )}
                  {activeTab === "custom" && (
                    <CustomSectionTab
                      data={form.customSections || []}
                      onChange={updateCustomSections}
                      onBack={goBack}
                      onNext={goNext}
                    />
                  )}
                  {activeTab === "templates" && (
                    <TemplatePicker
                      selected={template}
                      onSelect={(t) => {
                        setTemplate(t);
                        setCustomColor(null);
                      }}
                      customColor={customColor}
                      onColorChange={setCustomColor}
                      selectedFontStyle={fontStyle}
                      onFontStyleChange={setFontStyle}
                      onBack={goBack}
                      onPreview={() => setIsPreview(true)}
                    />
                  )}
                </div>
              </div>

              <div className="template-rail">
                {/* <TemplatePicker
                  selected={template}
                  onSelect={(t) => { setTemplate(t); setCustomColor(null); }}
                  customColor={customColor}
                  onColorChange={setCustomColor}
                /> */}

                <div className="mini-preview">
                  <div className="mini-preview-label">
                    <span
                      style={{
                        display: "inline-block",
                        width: 7,
                        height: 7,
                        borderRadius: "50%",
                        background: "#10b981",
                        marginRight: 4,
                      }}
                    />
                    Live Preview
                  </div>
                  <div className="mini-preview-frame">
                    <div className="mini-preview-scale">
                      <div
                        style={{
                          width: 600,
                          minHeight: PAGE_H,
                          overflow: "hidden",
                          background: "#fff",
                        }}
                      >
                        <ResumePreview
                          data={form}
                          templateId={template}
                          customColor={customColor}
                          fontStyleId={fontStyle}
                        />
                      </div>
                    </div>
                  </div>
                  <button className="mini-preview-fullbtn" onClick={() => setIsPreview(true)}>
                    View Full Preview →
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={2500}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
}
